/** @format */

import { all } from "redux-saga/effects"
import { combineReducers } from "redux"

import * as auth from "../app/modules/Auth/_redux/authRedux"
import * as homepage from "../app/modules/Homepage/_redux/homepageRedux"
import * as search from "../app/modules/SearchPage/_redux/searchRedux"
import * as reserve from "../app/modules/ReservePage/_redux/reserveRedux"
import * as account from "../app/modules/Account/_redux/accountRedux"
import { tokenReducer } from "../app/modules/OwnerContract/contractReducer"
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice"
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice"
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice"
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice"
import * as PassengersRedux from "../app/modules/Account/_redux/passengers/passengersActions"
import * as townshipsRedux from "../app/modules/Homepage/pages/widgets/components/redux"
import * as ProfileRedux from "../app/modules/profile/CrudAndRedux/ProfileRedux"
import * as OwnersRedux from "../app/modules/OwnerContract/redux"

export const rootReducer = combineReducers({
  auth: auth.reducer,
  account: account.reducer,
  homepage: homepage.reducer,
  search: search.reducer,
  reserve: reserve.reducer,
  customers: customersSlice.reducer,
  passengers: PassengersRedux.reducer,
  products: productsSlice.reducer,
  token: tokenReducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  townships: townshipsRedux.reducer,
  profile: ProfileRedux.reducer,
  owner: OwnersRedux.reducer,
})

export function* rootSaga() {
  yield all([auth.saga()])
}
